import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fiLineClamp]',
    standalone: false,
})
export class FiLineClampDirective implements OnInit {
    @Input() fiLineClamp: number;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit(): void {
        this.renderer.setStyle(this.elementRef.nativeElement, 'display', '-webkit-box');
        this.renderer.setStyle(this.elementRef.nativeElement, '-webkit-line-clamp', this.fiLineClamp || 1);
        this.renderer.setStyle(this.elementRef.nativeElement, '-webkit-box-orient', 'vertical');
        this.renderer.setStyle(this.elementRef.nativeElement, 'overflow', 'hidden');
        this.renderer.setStyle(this.elementRef.nativeElement, 'text-overflow', 'ellipsis');
        this.renderer.setStyle(this.elementRef.nativeElement, 'white-space', 'unset');
    }
}
